<template>
<div class="studySelector">
  <div class="label">{{title}}</div>
  <div class="selectorWrapper">
    <b-dropdown size="lg" class="studyButton" variant="outline-light" :text="buttonTitle">
      <b-dropdown-item v-for="study in studies" :key="study.extname" @click="onStudySelected(study.extname)">{{study.title}}</b-dropdown-item>
    </b-dropdown>
  </div>
</div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import PageNavigator from "@/services/PageNavigator";

  export default {
  name: 'StudySelector',

  props: {
    title: String
  },

  computed: {
    ...mapGetters(['studies']),
    ...mapState(['activeStudy', 'activeView']),

    buttonTitle() {
      return this.activeStudy ? this.activeStudy.title : "!"
    }
  },

  methods: {
    onStudySelected(studyName) {
      this.$store.dispatch('selectStudyAndPath', studyName)
      PageNavigator.navigateToDefaultPage(this.$router, this.activeStudy.defaultPage, this.activeStudy.extname, this.activeView.extname, this.activeView.defaultPath)
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  div.studySelector {
    padding-bottom: 1em;
  }

  .label {
    color: white;
    font-size: 1.5em;
    text-align: center;
  }

  .selectorWrapper {
    text-align: center;
  }

  /*.dropdown-toggle::after {*/
  /*  position: relative;*/
  /*}*/

  /*!* Align Bootstrap default Dropdown icon closer to vertical center of collapsed icon. *!*/
  /*.dropdown-toggle::after {*/
  /*  vertical-align: 0.15em;*/
  /*}*/

  /*!* Make Dropdown icon point right when collapsed, with Browser default vertical alignment. *!*/
  /*.collapsed.dropdown-toggle::after {*/
  /*  border-top: 0.3em solid transparent;*/
  /*  border-left: 0.3em solid;*/
  /*  border-bottom: 0.3em solid transparent;*/
  /*  border-right: 0;*/
  /*  vertical-align: unset;*/
  /*}*/

  .studyButton button  {
    /*font-size: 1.5em;*/
    /*background-color: transparent;*/
    padding-top: 0;
    padding-bottom: 0;
  }


</style>
